(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compositor-preview-test"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.prototypeReady === 'true') return;
      root.dataset.prototypeReady = 'true';
      const layout = root.querySelector('[data-prototype-layout]');
      const previewTrack = root.querySelector('[data-prototype-preview-track]');
      const shell = root.querySelector('[data-prototype-shell]');
      const controls = root.querySelector('[data-prototype-controls]');
      const panelWindow = root.querySelector('[data-prototype-panel-window]');
      const panelContent = root.querySelector('[data-prototype-panel-content]');
      const expandControl = root.querySelector('[data-prototype-expand]');
      const returnSentinel = root.querySelector('[data-prototype-return-sentinel]');
      const action = root.querySelector('[data-prototype-action]');
      const output = root.querySelector('[data-prototype-diagnostics]');
      const sectionHost = root.closest('.shopify-section');
      let siteHeader = sectionHost?.previousElementSibling || null;
      while (siteHeader && !siteHeader.classList.contains('section-header')) siteHeader = siteHeader.previousElementSibling;
      if (!siteHeader) {
        siteHeader = Array.from(document.querySelectorAll('.section-header')).find((candidate) => !candidate.classList.contains('shopify-section-group-header-group') && getComputedStyle(candidate).display !== 'none') || null;
      }
      if (siteHeader) siteHeader.style.setProperty('--tco-compositor-header-height',`${siteHeader.offsetHeight}px`);
      const siteHeaderWrapper = siteHeader?.querySelector('.header-wrapper') || null;
      const metrics = { scrollEvents:0, frames:0, writes:0, renderCalls:0, canvasPaints:0, layoutChanges:0, cls:0 };
      let frame = 0;
      let startY = 0;
      let endY = 1;
      let panelEndY = 2;
      let panelTravel = 0;
      let lastProgress = -1;
      let lastWidth = innerWidth;
      let lastShownAt = -Infinity;
      let lastSettled = '0';
      let tapExpanded = false;
      let tapExpandedAtY = 0;
      let tapAnimationTimer = 0;
      let headerReturnY = Number.POSITIVE_INFINITY;
      let headerReturned = false;
      let headerExitTimer = 0;
      let headerEnterFrame = 0;
      let headerEnterCleanupTimer = 0;
      const nativeScroll = CSS.supports('animation-timeline: scroll(root block)') && CSS.supports('animation-range: 0px 1px');
      const STAR_RATE = .4;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let starTileHeight = 1200;
      const show = (force = false) => {
        if (!force && performance.now() - lastShownAt < 200) return;
        lastShownAt = performance.now();
        output.value = `scroll ${metrics.scrollEvents} · frames ${metrics.frames}\nwrites ${metrics.writes} · renders ${metrics.renderCalls}\ncanvas ${metrics.canvasPaints} · layout ${metrics.layoutChanges}\nCLS ${metrics.cls.toFixed(4)} · progress ${Math.max(0,lastProgress).toFixed(3)}\ntimeline ${nativeScroll ? 'native' : 'fallback'} · scene literal`;
      };
      const measure = () => {
        const rect = layout.getBoundingClientRect();
        const stickyTop = parseFloat(getComputedStyle(shell).top) || 0;
        // Floored at 0: with the layout at the top of the page the shell is
        // already sticky-clamped at scroll 0, so this evaluated to -stickyTop.
        // A negative animation-range start gets clamped by the browser, which
        // squeezes the same 40% of clip into 16px less scroll — the collapse
        // then outruns the panel and the constant gap drifts shut.
        startY = Math.max(0,scrollY + rect.top - stickyTop);
        endY = startY + Math.max(1,layout.clientWidth * .4);
        const shellRect = shell.getBoundingClientRect();
        const rootRect = root.getBoundingClientRect();
        const mobilePattern = matchMedia('(max-width: 749px)').matches;
        const edgeStarX = mobilePattern ? 330 : 188;
        const edgeStarY = mobilePattern ? 234 : 292;
        const starOriginX = shellRect.left - rootRect.left - edgeStarX;
        root.style.setProperty('--prototype-star-origin-x',`${starOriginX}px`);
        root.style.setProperty('--prototype-seam-page-x',`${shellRect.left - rootRect.left}px`);
        root.style.setProperty('--prototype-seam-page-y',`${edgeStarY}px`);
        root.style.setProperty('--prototype-collapse-travel',`${endY - startY}px`);
        starTileHeight = parseFloat(getComputedStyle(root).getPropertyValue('--prototype-star-height')) || 1200;
        // Generous page length so later growth never runs off the last iteration.
        const starScrollSpan = Math.max(document.documentElement.scrollHeight,innerHeight) * 2;
        root.style.setProperty('--prototype-star-rate',String(STAR_RATE));
        root.style.setProperty('--prototype-star-iterations',String(Math.ceil(starScrollSpan * STAR_RATE / starTileHeight)));
        const panelStyle = getComputedStyle(panelWindow);
        const panelPaddingTop = parseFloat(panelStyle.paddingTop);
        const panelPaddingBottom = parseFloat(panelStyle.paddingBottom);
        panelTravel = Math.max(0,panelPaddingTop + action.offsetTop + action.offsetHeight - panelWindow.clientHeight + panelPaddingBottom);
        panelEndY = endY + Math.max(1,panelTravel);
        headerReturnY = panelEndY + (parseFloat(panelStyle.top) || 0) + panelWindow.offsetHeight - 1;
        root.style.setProperty('--prototype-collapse-start',`${startY}px`);
        root.style.setProperty('--prototype-collapse-end',`${endY}px`);
        root.style.setProperty('--prototype-panel-end',`${panelEndY}px`);
        root.style.setProperty('--prototype-panel-travel',`${panelTravel}px`);
        root.style.setProperty('--prototype-controls-height',`${panelWindow.offsetHeight + panelTravel}px`);
      };
      const setHeaderReturned = (returned) => {
        if (!siteHeader || returned === headerReturned) return;
        headerReturned = returned;
        clearTimeout(headerExitTimer);
        cancelAnimationFrame(headerEnterFrame);
        clearTimeout(headerEnterCleanupTimer);
        if (returned) {
          siteHeader.classList.remove('tco-compositor-header-exit');
          siteHeader.classList.add('tco-compositor-header-return');
          if (!siteHeaderWrapper || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          siteHeaderWrapper.style.setProperty('transition','none','important');
          siteHeaderWrapper.style.setProperty('opacity','0','important');
          siteHeaderWrapper.style.setProperty('transform','translate3d(0,-16px,0)','important');
          siteHeaderWrapper.style.setProperty('will-change','opacity,transform');
          headerEnterFrame = requestAnimationFrame(() => {
            headerEnterFrame = requestAnimationFrame(() => {
              headerEnterFrame = 0;
              if (!headerReturned) return;
              siteHeaderWrapper.style.setProperty('transition','opacity .36s ease, transform .36s cubic-bezier(.22,1,.36,1)','important');
              siteHeaderWrapper.style.setProperty('opacity','1','important');
              siteHeaderWrapper.style.setProperty('transform','translate3d(0,0,0)','important');
              headerEnterCleanupTimer = setTimeout(() => {
                if (!headerReturned) return;
                siteHeaderWrapper.style.removeProperty('transition');
                siteHeaderWrapper.style.removeProperty('opacity');
                siteHeaderWrapper.style.removeProperty('transform');
                siteHeaderWrapper.style.removeProperty('will-change');
              },400);
            });
          });
          return;
        }
        if (siteHeaderWrapper) {
          siteHeaderWrapper.style.removeProperty('transition');
          siteHeaderWrapper.style.removeProperty('opacity');
          siteHeaderWrapper.style.removeProperty('transform');
          siteHeaderWrapper.style.removeProperty('will-change');
        }
        siteHeader.classList.remove('tco-compositor-header-return');
        siteHeader.classList.add('tco-compositor-header-exit');
        headerExitTimer = setTimeout(() => siteHeader.classList.remove('tco-compositor-header-exit'),240);
      };
      const headerObserver = siteHeader && returnSentinel && 'IntersectionObserver' in window
        ? new IntersectionObserver(([entry]) => setHeaderReturned(!entry.isIntersecting && entry.boundingClientRect.bottom <= 0))
        : null;
      headerObserver?.observe(returnSentinel);
      const update = () => {
        frame = 0;
        metrics.frames += 1;
        const progress = Math.max(0,(scrollY - startY) / (endY - startY));
        const docked = progress >= .999 && scrollY < panelEndY;
        root.classList.toggle('is-preview-docked',docked);
        if (!headerObserver) setHeaderReturned(scrollY >= headerReturnY);
        if (!nativeScroll && !reducedMotion.matches) {
          root.style.setProperty('--prototype-star-shift',((Math.max(0,scrollY) * STAR_RATE) % starTileHeight).toFixed(2));
          metrics.writes += 1;
        }
        if (Math.abs(progress - lastProgress) < .0005) { show(); return; }
        lastProgress = progress;
        if (nativeScroll) {
          // DuckDuckGo (iOS) drops the fill-mode hold on clip-path once the
          // scroll passes the collapse range, so the clip snaps back to the
          // base style. Keep the base style equal to the settled end state:
          // one write per crossing, never per frame.
          const settled = progress >= 1 ? '1' : '0';
          if (settled !== lastSettled) {
            lastSettled = settled;
            root.style.setProperty('--prototype-progress',settled);
            metrics.writes += 1;
          }
        } else {
          root.style.setProperty('--prototype-progress',progress.toFixed(5));
          const panelOffset = Math.min(panelTravel,Math.max(0,scrollY - endY));
          root.style.setProperty('--prototype-panel-offset',`${panelOffset.toFixed(3)}px`);
          metrics.writes += 2;
        }
        show();
      };
      const collapseTapPreview = () => {
        if (!tapExpanded) return;
        tapExpanded = false;
        clearTimeout(tapAnimationTimer);
        root.classList.remove('is-tap-expanded');
        root.classList.add('is-tap-collapsing');
        expandControl.setAttribute('aria-expanded','false');
        expandControl.setAttribute('aria-label','Expand artwork preview');
        tapAnimationTimer = setTimeout(() => root.classList.remove('is-tap-collapsing'),320);
      };
      const toggleTapPreview = () => {
        if (tapExpanded) { collapseTapPreview(); return; }
        if (lastProgress < .999 || scrollY >= panelEndY) return;
        clearTimeout(tapAnimationTimer);
        tapExpanded = true;
        tapExpandedAtY = scrollY;
        root.classList.remove('is-tap-collapsing');
        root.classList.add('is-tap-expanded');
        expandControl.setAttribute('aria-expanded','true');
        expandControl.setAttribute('aria-label','Shrink artwork preview');
      };
      const onPreviewTap = (event) => {
        if (event.target.closest('button,summary')) return;
        toggleTapPreview();
      };
      const onScroll = () => {
        const currentScrollY = scrollY;
        // Any real scroll, up or down, returns an expanded preview to its docked size.
        if (tapExpanded && Math.abs(currentScrollY - tapExpandedAtY) > 8) collapseTapPreview();
        if (currentScrollY >= panelEndY - 24) collapseTapPreview();
        previousScrollY = currentScrollY;
        metrics.scrollEvents += 1;
        requestUpdate();
      };
      const requestUpdate = () => { if (!frame) frame = requestAnimationFrame(update); };
      let previousScrollY = scrollY;
      const backdropToggle = root.querySelector('[data-prototype-backdrop]');
      const tints = [['none','no tint'],['white','white tint'],['grey','grey tint'],['black','black tint']];
      let tintIndex = 0;
      backdropToggle.addEventListener('click',() => {
        tintIndex = (tintIndex + 1) % tints.length;
        const [tint,label] = tints[tintIndex];
        if (tint === 'none') delete root.dataset.previewTint;
        else root.dataset.previewTint = tint;
        backdropToggle.setAttribute('aria-label',`Preview background: ${label}`);
      });
      shell.addEventListener('click',onPreviewTap);
      expandControl.addEventListener('click',toggleTapPreview);
      addEventListener('scroll',onScroll,{ passive:true });
      // Also collapse on the scroll gesture itself, up or down, so it never
      // depends on the scroll position having moved yet (momentum, rubber-band
      // at the page edges, or a scroll the browser swallowed).
      let touchStartY = null;
      addEventListener('touchstart',(event) => { touchStartY = event.touches[0]?.clientY ?? null; },{ passive:true });
      addEventListener('touchmove',(event) => {
        if (!tapExpanded || touchStartY === null) return;
        if (Math.abs((event.touches[0]?.clientY ?? touchStartY) - touchStartY) > 6) collapseTapPreview();
      },{ passive:true });
      addEventListener('touchend',() => { touchStartY = null; },{ passive:true });
      addEventListener('wheel',(event) => { if (tapExpanded && Math.abs(event.deltaY) > 0) collapseTapPreview(); },{ passive:true });
      addEventListener('resize',() => {
        if (Math.abs(innerWidth - lastWidth) < 1) return;
        lastWidth = innerWidth;
        measure();
        requestUpdate();
      },{ passive:true });
      new ResizeObserver(() => { metrics.layoutChanges += 1; show(true); }).observe(controls);
      if ('PerformanceObserver' in window) {
        try { new PerformanceObserver((list) => { for (const entry of list.getEntries()) if (!entry.hadRecentInput) metrics.cls += entry.value; show(true); }).observe({ type:'layout-shift', buffered:true }); } catch (error) {}
      }
      measure();
      root.dataset.prototypeMeasured = 'true';
      requestUpdate();
      root.previewPrototypeMetrics = metrics;
      root.getPreviewPrototypeSnapshot = () => ({ ...metrics, nativeScroll, progress:lastProgress, tapExpanded, headerReturned, headerReturnY, headerReturnMode:headerObserver ? 'observer' : 'fallback', collapseEndY:endY, panelEndY, panelTravel, scrollHeight:document.documentElement.scrollHeight, controlTop:controls.getBoundingClientRect().top + scrollY, controlsHeight:controls.getBoundingClientRect().height, previewTrackHeight:previewTrack.getBoundingClientRect().height, controlViewportTop:panelWindow.getBoundingClientRect().top, panelWindowBottom:panelWindow.getBoundingClientRect().bottom, panelWindowHeight:panelWindow.getBoundingClientRect().height, panelWindowStickyTop:parseFloat(getComputedStyle(panelWindow).top), panelContentViewportTop:panelContent.getBoundingClientRect().top, actionBottom:action.getBoundingClientRect().bottom, panelBottomPadding:parseFloat(getComputedStyle(panelWindow).paddingBottom), shellTop:shell.getBoundingClientRect().top, shellHeight:shell.getBoundingClientRect().height, shellBackground:getComputedStyle(shell).backgroundColor, controlClip:getComputedStyle(panelWindow).clipPath, panelContentTransform:getComputedStyle(panelContent).transform, transform:getComputedStyle(root.querySelector('[data-prototype-plane]')).transform, headerPosition:siteHeader ? getComputedStyle(siteHeader).position : '', headerWrapperPosition:siteHeaderWrapper ? getComputedStyle(siteHeaderWrapper).position : '', headerOpacity:siteHeaderWrapper ? getComputedStyle(siteHeaderWrapper).opacity : '', headerAnimationCount:siteHeaderWrapper ? siteHeaderWrapper.getAnimations().length : 0, sentinelTop:returnSentinel.getBoundingClientRect().top, sentinelBottom:returnSentinel.getBoundingClientRect().bottom });
    };
    const setupAll = (scope = document) => scope.querySelectorAll('[data-compositor-test]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => setupAll(),{ once:true });
    else setupAll();
    document.addEventListener('shopify:section:load',(event) => setupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-spawn-backdrop"]) return;
  try {
    
  (() => {
    const setup = (backdrop) => {
      if (backdrop.dataset.tcoHeaderSpawnReady === 'true') return;
      const section = backdrop.closest('.shopify-section');
      const headerSection = section?.previousElementSibling;
      if (!section || !headerSection) return;
      backdrop.dataset.tcoHeaderSpawnReady = 'true';
      const sync = () => section.style.setProperty('--tco-header-spawn-height', `${headerSection.offsetHeight}px`);
      sync();
      const observer = new ResizeObserver(sync);
      observer.observe(headerSection);
    };
    const setupAll = (scope = document) => scope.querySelectorAll('[data-tco-header-spawn-backdrop]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupAll(), { once: true });
    else setupAll();
    document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsConfiguredAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.mobileStickyQuery = window.matchMedia('(max-width: 989px)');
      this.headerIsAlwaysSticky = this.headerIsConfiguredAlwaysSticky || this.mobileStickyQuery.matches;
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerSizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerSizeObserver.observe(this);

      this.onMobileStickyChange = () => {
        this.setHeaderHeight();
        // Section-owned: measure only, never restore Dawn's sticky classes.
        if (this.dataset.tcoSectionOwned === 'true') return;
        this.headerIsAlwaysSticky = this.headerIsConfiguredAlwaysSticky || this.mobileStickyQuery.matches;
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
          this.header.classList.remove('shopify-section-header-hidden', 'animate');
        } else {
          this.reset();
        }
      };
      this.mobileStickyQuery.addEventListener('change', this.onMobileStickyChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // On section-owned templates the page's own section pins and fades the
      // header. Keep the height measuring above (the drawer and other theme
      // parts read --header-height), but take no part in the scroll.
      if (this.dataset.tcoSectionOwned === 'true') {
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
        this.setupSectionOwned();
        return;
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      const height = this.offsetHeight;
      if (!height) return;
      const value = `${height}px`;
      this.header.classList.toggle('tco-header-overlay', getComputedStyle(this).position === 'absolute');
      if (this.header.style.getPropertyValue('--tco-header-box-height') !== value) {
        this.header.style.setProperty('--tco-header-box-height', value);
      }
      if (document.documentElement.style.getPropertyValue('--header-height') !== value) {
        document.documentElement.style.setProperty('--header-height', value);
      }
      // Same number under a name nothing redeclares: the sticker wizard's
      // design tokens set their own --header-height on #sticker-wizard-app,
      // which hides this one from anything inside the wizard.
      if (document.documentElement.style.getPropertyValue('--tco-site-header-height') !== value) {
        document.documentElement.style.setProperty('--tco-site-header-height', value);
      }
    }

    /* Sticker page (18 Sep 2026). The wizard used to carry this job, but it
       was lost when the preview was ported from the test page, leaving the
       header unmanaged: it scrolled off and never came back. It now lives
       here and only WATCHES the wizard, so the wizard needs no changes.
       The preview test page keeps its own copy, so this skips that page. */
    setupSectionOwned() {
      const wizard = document.querySelector('.section-sticker-wizard');
      if (!wizard || !('IntersectionObserver' in window)) return;
      const header = this.header;
      const wrapper = this;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let pastWizard = false;
      let returned = false;
      let exitTimer = 0;
      let enterFrame = 0;
      let enterCleanupTimer = 0;
      let coverFrame = 0;

      const clearEnter = () => {
        ['transition', 'transform', 'will-change'].forEach((property) => wrapper.style.removeProperty(property));
        header.classList.remove('tco-header-glass-hidden', 'tco-header-glass-fading');
      };

      // Fade the header's contents in; never the wrapper (see GLASS-SAFE
      // FADES in the styles above).
      const fadeGlassIn = () => {
        header.classList.add('tco-header-glass-fading');
        header.classList.remove('tco-header-glass-hidden');
      };

      // Transplanted from the test section's setHeaderReturned(): same
      // classes (renamed), same timings, same double-frame enter.
      const setReturned = (next) => {
        if (next === returned) return;
        returned = next;
        clearTimeout(exitTimer);
        cancelAnimationFrame(enterFrame);
        clearTimeout(enterCleanupTimer);
        if (next) {
          hiddenAway = false; // the slide-in below takes over the in-flow fade
          clearEnter();
          header.classList.remove('tco-header-exit');
          header.classList.add('tco-header-return');
          if (reducedMotion.matches) return;
          header.classList.add('tco-header-glass-hidden');
          wrapper.style.setProperty('transition', 'none', 'important');
          wrapper.style.setProperty('transform', 'translate3d(0,-16px,0)', 'important');
          wrapper.style.setProperty('will-change', 'transform');
          enterFrame = requestAnimationFrame(() => {
            enterFrame = requestAnimationFrame(() => {
              enterFrame = 0;
              if (!returned) return;
              wrapper.style.setProperty('transition', 'transform .36s cubic-bezier(.22,1,.36,1)', 'important');
              wrapper.style.setProperty('transform', 'none', 'important');
              fadeGlassIn();
              enterCleanupTimer = setTimeout(() => {
                if (returned) clearEnter();
              }, 400);
            });
          });
          return;
        }
        clearEnter();
        header.classList.remove('tco-header-return');
        header.classList.add('tco-header-exit');
        exitTimer = setTimeout(() => {
          header.classList.remove('tco-header-exit');
          hideIfAway();
        }, 240);
      };

      /* IN-FLOW FADE (19 Sep 2026). While the wizard is in use the header
         sits in the page and scrolls away; scrolling back up it used to snap
         in. Now it is hidden while off screen and fades in as it arrives,
         over the always-purple spawn strip. Only in that in-flow state: the
         pinned header never leaves the screen, and the returned one has its
         own slide-in. The site-wide return fade skips this section so the
         two never stack. Off with reduced motion and in lite mode. */
      header.dataset.noReturnFade = '';
      let away = false;
      let hiddenAway = false;
      const inFlow = () =>
        !returned && !header.classList.contains('tco-header-pinned') && !header.classList.contains('tco-header-exit');
      const fadeAllowed = () =>
        !reducedMotion.matches && !document.documentElement.classList.contains('tco-lite-motion');

      function hideIfAway() {
        if (!away || hiddenAway || !inFlow() || !fadeAllowed()) return;
        hiddenAway = true;
        clearTimeout(enterCleanupTimer);
        header.classList.remove('tco-header-glass-fading');
        header.classList.add('tco-header-glass-hidden');
      }

      const fadeInFlow = () => {
        if (!hiddenAway) return;
        hiddenAway = false;
        if (!inFlow()) return clearEnter();
        fadeGlassIn();
        enterCleanupTimer = setTimeout(() => {
          if (!hiddenAway && inFlow()) clearEnter();
        }, 400);
      };

      /* A viewport and a half of margin (20 Sep 2026): the header is only
         counted as away once it is far above, and it is brought back long
         before it could be seen. In normal wizard use it therefore never
         hides, so scrolling up drops the whole header into view instead of
         showing an empty strip that fills in afterwards. */
      new IntersectionObserver(([entry]) => {
        away = !entry.isIntersecting;
        if (away) hideIfAway();
        else fadeInFlow();
      }, { rootMargin: '150% 0px' }).observe(header);

      // Before Begin the wizard shows its cover (or the reorder list, which
      // uses the same .wizard-cover); the header is then simply pinned.
      const syncState = () => {
        coverFrame = 0;
        // Never change state under an open menu: the popup lives inside the
        // header, so an exit/return would drag it along. Catch up on close.
        if (document.documentElement.classList.contains('tco-menu-scroll-locked')) return;
        const pinned = Boolean(wizard.querySelector('.wizard-cover'));
        if (header.classList.contains('tco-header-pinned') !== pinned) {
          header.classList.toggle('tco-header-pinned', pinned);
        }
        setReturned(!pinned && pastWizard);
      };

      // Past the wizard = its section has scrolled entirely above the screen.
      new IntersectionObserver(([entry]) => {
        pastWizard = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        syncState();
      }).observe(wizard);

      // The wizard re-renders its own markup; check for the cover at most
      // once a frame (the check itself is a single querySelector).
      new MutationObserver(() => {
        if (!coverFrame) coverFrame = requestAnimationFrame(syncState);
      }).observe(wizard, { childList: true, subtree: true });

      document.addEventListener('tco:menu-closed', syncState);
      syncState();
    }

    disconnectedCallback() {
      if (this.hideHeaderOnScrollUp) this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileStickyQuery?.removeEventListener('change', this.onMobileStickyChange);
      this.headerSizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll(coordinatedScrollTop) {
      if (document.documentElement.classList.contains('tco-menu-scroll-locked')) return;
      const scrollTop = Number.isFinite(coordinatedScrollTop)
        ? coordinatedScrollTop
        : window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const iOSWebKit =
      /iP(?:hone|ad|od)/i.test(navigator.userAgent) ||
      (/Mac/i.test(navigator.platform) && navigator.maxTouchPoints > 1);
    const supported =
      !iOSWebKit &&
      typeof CSS !== 'undefined' &&
      CSS.supports?.('backdrop-filter', 'url("#tco-liquid-glass-distortion")');
    const enhance = (scope = document) => {
      scope.querySelectorAll('[data-tco-liquid-glass]').forEach((surface) => {
        surface.classList.toggle('has-svg-backdrop-distortion', supported);
      });
    };
    enhance();
    document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  })();

  document.querySelectorAll('.menu-drawer-backdrop').forEach((backdrop) => {
    backdrop.addEventListener('click', () => {
      const details = backdrop.closest('details');
      const summary = details && details.querySelector('summary');
      if (summary) summary.click();
    });
  });
  /* TCO menu-open flag (18 Sep 2026). This used to freeze the page by fixing
     <body> in place; the page now stays scrollable behind the menu. The
     class name is kept because the header's z-index raise and scroll guards
     read it: while it is set, the header never hides or changes state. */
  (() => {
    const root = document.documentElement;
    let activeMenu = null;
    const attached = new WeakSet();

    const unlock = () => {
      if (!activeMenu) return;
      activeMenu = null;
      root.classList.remove('tco-menu-scroll-locked');
      document.dispatchEvent(new CustomEvent('tco:menu-closed'));
    };

    const attach = () => {
      const menu = document.getElementById('Details-menu-drawer-container');
      if (!menu || attached.has(menu)) return;
      attached.add(menu);
      const sync = () => {
        if (!menu.open) {
          if (activeMenu === menu) unlock();
          return;
        }
        if (activeMenu === menu) return;
        unlock();
        activeMenu = menu;
        root.classList.add('tco-menu-scroll-locked');
      };
      menu.addEventListener('toggle', sync);
      sync();
    };

    attach();
    window.addEventListener('resize', () => {
      const host = activeMenu?.closest('header-drawer');
      if (host && window.getComputedStyle(host).display === 'none') {
        activeMenu.querySelector('summary')?.click();
      }
    });
    document.addEventListener('shopify:section:load', attach);
    document.addEventListener('shopify:section:unload', (event) => {
      if (activeMenu && event.target.contains(activeMenu)) unlock();
    });
  })();
  /* Mobile visual-effects preference. The control is injected so it stays at
     the bottom of Dawn's existing utility area without modifying its snippet. */
  (() => {
    const storageKey = 'tco-performance-mode';
    const validModes = ['auto', 'full', 'lite'];
    const readMode = () => {
      // ?tco-mode wins for this page view (see the same override in
      // sticker-wizard-wordmark.liquid). Without this, installing the control
      // re-applied the saved preference after load and undid the override.
      try {
        const requested = new URLSearchParams(window.location.search).get('tco-mode');
        if (validModes.includes(requested)) return requested;
      } catch (error) {
        // Fall through to the saved preference.
      }
      try {
        const saved = localStorage.getItem(storageKey);
        return validModes.includes(saved) ? saved : 'auto';
      } catch (error) {
        return 'auto';
      }
    };
    const applyPreferenceClass = (mode) => {
      document.documentElement.dataset.tcoPerformanceMode = mode;
      if (mode === 'full') document.documentElement.classList.remove('tco-lite-motion');
      if (mode === 'lite') document.documentElement.classList.add('tco-lite-motion');
    };
    const installPerformanceControl = () => {
      const utilityLinks = document.querySelector('#Details-menu-drawer-container .menu-drawer__utility-links');
      if (!utilityLinks || utilityLinks.querySelector('[data-tco-performance-control]')) return;
      const mode = readMode();
      applyPreferenceClass(mode);
      // "Auto (Full)" / "Auto (Lite)": what Auto picks on this device, as
      // worked out by the sticker-wizard-wordmark snippet at page load.
      const autoMode = document.documentElement.dataset.tcoAutoMode;
      const autoSuffix = (value) =>
        value === 'auto' && (autoMode === 'full' || autoMode === 'lite')
          ? ` (${autoMode[0].toUpperCase()}${autoMode.slice(1)})`
          : '';
      const control = document.createElement('fieldset');
      control.className = 'tco-performance-control';
      control.dataset.tcoPerformanceControl = '';
      control.innerHTML = `
        <legend>Visual effects</legend>
        <div class="tco-performance-options">
          ${validModes
            .map(
              (value) => `
            <label>
              <input type="radio" name="tco-performance-mode" value="${value}"${mode === value ? ' checked' : ''}>
              <span>${value[0].toUpperCase()}${value.slice(1)}${autoSuffix(value)}</span>
            </label>`
            )
            .join('')}
        </div>`;
      control.addEventListener('change', (event) => {
        const nextMode = event.target?.value;
        if (!validModes.includes(nextMode)) return;
        try {
          if (nextMode === 'auto') localStorage.removeItem(storageKey);
          else localStorage.setItem(storageKey, nextMode);
        } catch (error) {
          applyPreferenceClass(nextMode);
        }
        window.location.reload();
      });
      utilityLinks.appendChild(control);
    };
    installPerformanceControl();
    document.addEventListener('shopify:section:load', installPerformanceControl);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-sticker-prices"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const quantities = [10, 25, 50, 100, 200];
    const money = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    });

    function calculatePreviewPrice(quantity, widthCm, heightCm) {
      const referencePrice = 15
        + 0.6666667 * (quantity - 10)
        - 0.0666667 * Math.max(0, quantity - 25)
        - 0.3 * Math.max(0, quantity - 50)
        + 0.15 * Math.max(0, quantity - 100);

      return referencePrice * ((widthCm * heightCm) / 42.25);
    }

    function setRollingValue(element, value) {
      const nextValue = String(value);
      const previousValue = element.dataset.rollingValue || '';
      const canReuse = element.children.length === nextValue.length
        && [...element.children].every((child, index) => {
          const isDigit = /\d/.test(nextValue[index]);
          return isDigit === child.classList.contains('popular-sticker-prices__rolling-digit');
        });

      if (!canReuse) {
        element.replaceChildren();

        [...nextValue].forEach((character, index) => {
          if (!/\d/.test(character)) {
            element.append(document.createTextNode(character));
            return;
          }

          const digit = document.createElement('span');
          const strip = document.createElement('span');
          digit.className = 'popular-sticker-prices__rolling-digit';
          strip.className = 'popular-sticker-prices__rolling-strip';
          strip.style.setProperty('--popular-digit', /\d/.test(previousValue[index]) ? previousValue[index] : character);

          for (let number = 0; number <= 9; number += 1) {
            const reelNumber = document.createElement('span');
            reelNumber.textContent = number;
            strip.append(reelNumber);
          }

          digit.append(strip);
          element.append(digit);
        });
      }

      window.requestAnimationFrame(() => {
        let digitIndex = 0;
        [...nextValue].forEach((character) => {
          if (!/\d/.test(character)) return;
          const strips = element.querySelectorAll('.popular-sticker-prices__rolling-strip');
          strips[digitIndex]?.style.setProperty('--popular-digit', character);
          digitIndex += 1;
        });
      });

      element.dataset.rollingValue = nextValue;
    }

    function renderPopularStickerPrices(root) {
      const quantity = Number(root.dataset.quantity);
      const calculator = typeof window.calculateStickerPrice === 'function'
        ? window.calculateStickerPrice
        : typeof calculateStickerPrice === 'function'
          ? calculateStickerPrice
          : calculatePreviewPrice;

      root.querySelectorAll('[data-popular-sticker-price]').forEach((card) => {
        const totalElement = card.querySelector('[data-popular-total]');
        const accessibleTotalElement = card.querySelector('[data-popular-total-accessible]');
        const eachElement = card.querySelector('[data-popular-each]');

        const widthCm = Number(card.dataset.widthMm) / 10;
        const heightCm = Number(card.dataset.heightMm) / 10;
        const total = calculator(quantity, widthCm, heightCm);

        const formattedTotal = money.format(total);
        setRollingValue(totalElement, formattedTotal);
        accessibleTotalElement.textContent = formattedTotal;
        eachElement.textContent = `${money.format(total / quantity)} each`;
      });

      return true;
    }

    function initializeQuantityControl(root) {
      if (root.dataset.quantityControlReady === 'true') return;

      const slider = root.querySelector('[data-popular-quantity-slider]');
      const sliderTrack = root.querySelector('[data-popular-slider-track]');
      if (!slider) return;

      root.dataset.quantityControlReady = 'true';

      const updateQuantity = () => {
        const quantity = quantities[Number(slider.value)] || 100;
        const progress = (Number(slider.value) / (quantities.length - 1)) * 100;
        root.dataset.quantity = quantity;
        sliderTrack?.style.setProperty('--slider-progress', `${progress}%`);
        slider.setAttribute('aria-valuetext', `${quantity} stickers`);
        const headingQuantity = root.querySelector('[data-popular-heading-quantity]');
        const accessibleHeadingQuantity = root.querySelector('[data-popular-heading-quantity-accessible]');
        if (headingQuantity) setRollingValue(headingQuantity, quantity);
        if (accessibleHeadingQuantity) accessibleHeadingQuantity.textContent = quantity;
        renderPopularStickerPrices(root);
      };

      slider.addEventListener('input', updateQuantity);
      updateQuantity();
    }

    function initializeCutoutSurface(root) {
      if (root.dataset.cutoutSurfaceReady === 'true') return;

      const surface = root.querySelector('[data-popular-cutout-surface]');
      const surfaceFill = root.querySelector('[data-popular-surface-fill]');
      const cards = [...root.querySelectorAll('[data-popular-sticker-price]')];

      if (!surface || !surfaceFill || !cards.length) return;

      root.dataset.cutoutSurfaceReady = 'true';
      let layoutFrame = 0;

      const update = () => {
        layoutFrame = 0;
        const rootBounds = root.getBoundingClientRect();
        const width = Math.max(1, root.offsetWidth);
        const height = Math.max(1, root.offsetHeight);
        const radius = 18;
        const paths = [`M0 0 H${width} V${height} H0 Z`];

        surface.setAttribute('viewBox', `0 0 ${width} ${height}`);

        cards.forEach((card) => {
          const cardBounds = card.getBoundingClientRect();
          const x = cardBounds.left - rootBounds.left;
          const y = cardBounds.top - rootBounds.top;
          const right = x + cardBounds.width;
          const bottom = y + cardBounds.height;
          const r = Math.min(radius, cardBounds.width / 2, cardBounds.height / 2);

          paths.push(
            `M${x + r} ${y}`,
            `H${right - r}`,
            `Q${right} ${y} ${right} ${y + r}`,
            `V${bottom - r}`,
            `Q${right} ${bottom} ${right - r} ${bottom}`,
            `H${x + r}`,
            `Q${x} ${bottom} ${x} ${bottom - r}`,
            `V${y + r}`,
            `Q${x} ${y} ${x + r} ${y}`,
            'Z'
          );
        });

        surfaceFill.setAttribute('d', paths.join(' '));
      };

      const requestUpdate = () => {
        window.cancelAnimationFrame(layoutFrame);
        layoutFrame = window.requestAnimationFrame(update);
      };

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(requestUpdate);
        observer.observe(root);
        cards.forEach((card) => observer.observe(card));
      }

      window.addEventListener('resize', requestUpdate, { passive: true });
      document.fonts?.ready.then(requestUpdate);
      requestUpdate();
    }

    let retryTimer = 0;
    function initializePopularStickerPrices(attempt = 0) {
      const roots = [...document.querySelectorAll('[data-popular-sticker-prices]')];
      roots.forEach(initializeCutoutSurface);
      roots.forEach(initializeQuantityControl);
      const rendered = roots.every(renderPopularStickerPrices);

      if (!rendered && attempt < 200) {
        window.clearTimeout(retryTimer);
        retryTimer = window.setTimeout(() => initializePopularStickerPrices(attempt + 1), 50);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializePopularStickerPrices(), { once: true });
    } else {
      initializePopularStickerPrices();
    }

    window.addEventListener('load', () => initializePopularStickerPrices());
    document.addEventListener('shopify:section:load', () => initializePopularStickerPrices());
  })();

  } catch(e) { console.error(e); }
})();
})();
